<script setup>
  const isOpen = useHeaderSlidingMenu()

  const ats = useAts()
  const { user } = useUser()

  const settingsLink = computed(() => {
    if (ats.value?.isUserRole(['admin'])) return '/ats/parametres/collaborateurs'
    if (ats.value?.isUserRole(['director'])) return '/ats/parametres/offres'
    return '/ats/parametres/mon-profil'
  })
</script>

<template>
  <div
    @click.self="isOpen = false"
    :class="[
      'fixed bottom-0 left-0 right-0 top-16 bg-black duration-500 md:hidden',
      isOpen ? 'bg-opacity-50 backdrop-blur' : 'pointer-events-none bg-opacity-0'
    ]"
  >
    <div
      :class="[
        'flex max-h-full flex-col overflow-y-auto px-2 pb-6 pt-10 font-special text-lg font-bold shadow duration-500',
        isOpen ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0',
        !ats.isAts ? 'bg-white' : 'bg-tarawera-900 text-white'
      ]"
    >
      <template v-if="!ats.isAts">
        <NuxtLink class="p-2 outline-none duration-300 hover:text-viking-500" target="_blank" to="https://pp.profilpublic.fr/contacter-profilpublic"
          >Nous contacter</NuxtLink
        >

        <NuxtLink
          class="p-2 outline-none duration-300 hover:text-viking-500"
          v-for="item in MAIN_NAV_ITEMS"
          :key="item.to"
          :to="item.to"
          :target="item.external ? '_blank' : undefined"
        >
          <Tooltip :content="item.tooltip" placement="bottom-start">{{ item.label }}</Tooltip>
        </NuxtLink>

        <NuxtLink class="p-2 outline-none duration-300 hover:text-viking-500" to="/ats-profilpublic">
          <Button> Logiciel ATS </Button>
        </NuxtLink>

        <NuxtLink
          class="space-x-2 p-2 font-special outline-none duration-300 hover:text-viking-500"
          v-if="user && !user.isEmployer"
          target="_blank"
          to="https://media.profilpublic.fr/wp-content/uploads/2024/10/Guide-candidat-Profil-Public.pdf"
        >
          <Icon fixed-width name="book-open-cover" type="regular" />
          <span>Guide Candidat</span>
        </NuxtLink>
      </template>

      <template v-else>
        <NuxtLink
          class="p-2 font-special outline-none duration-300 hover:text-viking-500"
          v-if="ats.hasOption('recruitmentRequest') && !ats.isUserRole(['communicator'])"
          to="/ats/demandes-recrutement"
          >DAR</NuxtLink
        >

        <NuxtLink class="p-2 font-special outline-none duration-300 hover:text-viking-500" v-if="!ats.isUserRole(['communicator'])" to="/ats/offres"
          >Offres</NuxtLink
        >

        <NuxtLink
          class="block p-2 font-special outline-none duration-300 hover:text-viking-500"
          v-if="ats.isSubscribed(['ATS', 'MEI']) && ats.isUserRole(['admin', 'director', 'manager', 'contributor'])"
          to="/ats/candidatures-spontanees"
          >Candidatures spontanées</NuxtLink
        >

        <NuxtLink
          class="block p-2 font-special outline-none duration-300 hover:text-viking-500"
          v-if="ats.isSubscribed('ATS') && ats.isUserRole(['admin', 'director'])"
          to="/ats/cvtheque"
          >CVthèque</NuxtLink
        >

        <NuxtLink
          class="block p-2 font-special outline-none duration-300 hover:text-viking-500"
          v-if="ats.isSubscribed('ATS') && ats.isUserRole(['admin', 'director', 'communicator'])"
          to="/ats/statistiques"
          >Statistiques</NuxtLink
        >

        <div class="p-2" v-if="ats.isUserRole(['admin', 'director'])">
          <AtsEmailNotification label="Messagerie" />
        </div>

        <NuxtLink class="space-x-2 p-2 font-special outline-none duration-300 hover:text-viking-500" :to="settingsLink">
          <Icon fixed-width name="gear" />
          <span>Paramètres</span>
        </NuxtLink>
      </template>
    </div>
  </div>
</template>
